import React from 'react';
import ErrorMessage from './ErrorMessage';
import { getLabel } from '../InitData';

export default function Loader(props) {
    if (props.error) {
        return <ErrorMessage text={getLabel('general.error_fetching_data')} />
    }

    return (
        <div className="c_41">
            <div className="c_41_1"></div>
        </div>
    );
}
